/**
 * GET /admin/info 返回的 companyFulfillmentSites：公司 ID 与范围内履约网点 ID 列表。
 * 持久化到 localStorage，供路由守卫之外的脚本或其它模块读取（与 Vuex 在 GetInfo 时同步写入）。
 */
export const COMPANY_FULFILLMENT_SITES_STORAGE_KEY = 'mallAdminCompanyFulfillmentSites'

/**
 * @param {unknown} raw
 * @returns {{ companyId: number, siteIds: number[] }[]}
 */
export function normalizeCompanyFulfillmentSites(raw) {
  if (!Array.isArray(raw)) return []
  const out = []
  for (let i = 0; i < raw.length; i++) {
    const x = raw[i]
    if (!x || typeof x !== 'object') continue
    const companyId = Number(x.companyId)
    const siteIds = Array.isArray(x.siteIds)
      ? x.siteIds.map((id) => Number(id)).filter((n) => !Number.isNaN(n))
      : []
    if (Number.isNaN(companyId)) continue
    out.push({ companyId, siteIds })
  }
  return out
}

export function setStoredCompanyFulfillmentSites(raw) {
  const normalized = normalizeCompanyFulfillmentSites(raw)
  try {
    localStorage.setItem(COMPANY_FULFILLMENT_SITES_STORAGE_KEY, JSON.stringify(normalized))
  } catch (e) {
    console.warn('[companyFulfillmentSites] localStorage.setItem failed', e)
  }
  return normalized
}

export function getStoredCompanyFulfillmentSites() {
  try {
    const s = localStorage.getItem(COMPANY_FULFILLMENT_SITES_STORAGE_KEY)
    if (s == null || s === '') return []
    return normalizeCompanyFulfillmentSites(JSON.parse(s))
  } catch (e) {
    return []
  }
}

export function removeStoredCompanyFulfillmentSites() {
  try {
    localStorage.removeItem(COMPANY_FULFILLMENT_SITES_STORAGE_KEY)
  } catch (e) {
    console.warn('[companyFulfillmentSites] localStorage.removeItem failed', e)
  }
}



// WEBPACK FOOTER //
// ./src/utils/companyFulfillmentSitesStorage.js